<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getOpenid } from './utils/actions'
import { isWeixin, urlGet } from './utils/common'
export default {
  name: 'App',
  created () {
    let _this = this
    let appId = 'wx9055001470d77927'
    if (location.href.indexOf('h5.edaijia') < 0) {
      appId = 'wxbc875ef9b329cfcf'
    }
    const redirectUri = encodeURIComponent(location.href.replace(/#.*/, '').replace(/(code|state)=[^&]+[&]?/g, '').replace(/&$/, ''))
    const baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_base&state=null#wechat_redirect'
    _this.setSession()
    if (isWeixin() && !localStorage.getItem('recruit_openid')) {
      if (!urlGet().code) {
        location.replace(baseUrl)
      } else {
        getOpenid({
          code: urlGet().code
        }).then((res) => {
          if (res.code !== 0) {
            location.replace(baseUrl)
            return
          }
          let openid = res.data.openid
          _this.$store.commit('OPENID', openid)
        })
        if (location.hash == '#/') {//eslint-disable-line
          _this.$router.push({ path: 'index' })
        }
      }
    } else {
      if (location.hash == '#/') {//eslint-disable-line
        _this.$router.push({ path: 'index' })
      }
    }
    let urlParams = urlGet()
    if (urlParams.work && urlParams.work * 1 === 4) {
      document.title = '轻享司机加盟'
    }
  },

  methods: {
    setSession () {
      if (localStorage.getItem('store')) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(localStorage.getItem('store'))
          )
        )
      }
      /* 在页面刷新时将vuex里的信息保存到sessionStorage里 */
      window.addEventListener('beforeunload', () => {
        localStorage.setItem('store', JSON.stringify(this.$store.state))
      })
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/App.vue